import { Grid, styled, StepLabel as BaseStepLabel } from '@mui/material'
import { LoadingButton } from '@mui/lab'

export const Button = styled(LoadingButton)(({ theme }) => ({
  width: 180,
  '&:last-child': {
    marginLeft: theme.spacing(1.5),
  },
}))

export const StepLabel = styled(BaseStepLabel)(({ theme }) => ({
  [theme.breakpoints.down('sm')]: {
    flexDirection: 'column',
    gap: theme.spacing(1),

    '& span': {
      textAlign: 'center',
    },
  },
}))

export const Header = styled(Grid)({})

export const StepContent = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  flex: '1 1 0',
  minHeight: 0,
  overflow: 'hidden',
})
